function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.126 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H12.126C12.5701 14.2748 14.1362 13 16 13C17.8638 13 19.4299 14.2748 19.874 16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H19.874C19.4299 19.7252 17.8638 21 16 21C14.1362 21 12.5701 19.7252 12.126 18ZM4.12602 8H3C2.44772 8 2 7.55228 2 7C2 6.44772 2.44772 6 3 6H4.12602C4.57006 4.27477 6.13616 3 8 3C9.86384 3 11.4299 4.27477 11.874 6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H11.874C11.4299 9.72523 9.86384 11 8 11C6.13616 11 4.57006 9.72523 4.12602 8ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9ZM16 19C17.1046 19 18 18.1046 18 17C18 15.8954 17.1046 15 16 15C14.8954 15 14 15.8954 14 17C14 18.1046 14.8954 19 16 19Z"
});

var SvgSlider = function SvgSlider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#42A5F5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slider.c6e3efec.svg";
export { ForwardRef as ReactComponent };